// tabs
export const activeTab = [
  {
    active: 1,
    titleOptions: ["各省市","实际", "采集量"],
    title: "各省市实际采集量", // 按来源统计
    titleS: "",
    tip: " (汇总统计)",
    show: true, // 默认初始化高亮
    children: []
  },
  // {
  //   active: 2,
  //   titleOptions: ["答题", "网民", "区域", "分布"],
  //   title: "答题网民区域分布", // 按ip统计
  //   titleS: "",
  //   tip: " (汇总统计)",
  //   show: false,
  //   children: [
  //     {
  //       id: 1,
  //       identification: 'first',
  //       title: "样本采集（汇总统计）",
  //       parentId: 2,
  //     },
  //     {
  //       id: 2,
  //       identification: 'second',
  //       title: "主问卷/专题采集量（数量汇总）",
  //       parentId: 2,
  //     }
  //   ]
  // },
  {
    active: 12,
    titleOptions: ["答题", "网民", "常住地", "分布"],
    title: "答题网民常住地分布", // 按来源统计
    titleS: "",
    tip: " (汇总统计)",
    show: false,
    children: [
      {
        id: 1,
        identification: 'first',
        title: "样本采集（汇总统计）",
        parentId: 12,
      },
      {
        id: 2,
        identification: 'second',
        title: "主问卷/专题采集量（数量汇总）",
        parentId: 12,
      }
    ]
  },
  {
    active: 6,
    titleOptions: ["各链接", "采集量"],
    title: "各链接采集量",
    titleS: "",
    tip: " ", // 占位,
    show: false,
    children: []
  },
  {
    active: 5,
    titleOptions: ["发起", "单位"],
    title: "发起单位",
    titleS: "",
    tip: " ", // 占位,
    show: false,
    children: [
      {
        id: 1,
        identification: 'first',
        title: "发起单位",
        parentId: 5,
      },
      {
        id: 2,
        identification: 'second',
        title: "联合发起单位",
        parentId: 5,
      },
    ]
  },
  {
    active: 8,
    titleOptions: ["志愿", "服务"],
    title: "志愿服务",
    titleS: "",
    tip: " ", // 占位,
    show: false,
    children: [
      {
        id: 1,
        identification: 'first',
        title: "网安联·志愿服务站",
        parentId: 8,
      },
      {
        id: 2,
        identification: 'second',
        title: "网安联·志愿服务队",
        parentId: 8,
      },
      {
        id: 4,
        identification: 'four',
        title: "其他志愿团体",
        parentId: 8,
      },
      {
        id: 5,
        identification: 'five',
        title: "公益讲师",
        parentId: 8,
      },
      {
        id: 3,
        identification: 'three',
        title: "志愿者",
        parentId: 8,
      }
    ]
  },
  {
    active: 11,
    titleOptions: ["学校"],
    title: "学校",
    titleS: "",
    tip: " ", // 占位,
    show: false,
    children: [
      {
        id: 1,
        identification: 'first',
        title: "高校",
        parentId: 11,
        children: [
          {
            id: 1,
            identification: 'first',
            title: "高校",
            parentId: 11,
          },
          {
            id: 2,
            identification: 'second',
            title: "七大区",
            parentId: 11,
          },
          {
            id: 3,
            identification: 'three',
            title: "省份",
            parentId: 11,
          }
        ]
      },
      {
        id: 2,
        identification: 'second',
        title: "职校",
        parentId: 11,
      },
      {
        id: 3,
        identification: 'three',
        title: "中小学",
        parentId: 11,
      }
    ]
  },
  {
    active: 13,
    titleOptions: ["带平安", "·", "回家乡"],
    title: "带平安·回家乡",
    titleS: "",
    tip: " ", // 占位,
    show: false,
    children: [
      {
        id: 1,
        identification: 'first',
        title: "学校",
        parentId: 13,
      },{
        id: 2,
        identification: 'second',
        title: "个人",
        parentId: 13,
      },
      {
        id: 3,
        identification: 'three',
        title: "七大区",
        parentId: 13,
      },
      {
        id: 4,
        identification: 'four',
        title: "省份",
        parentId: 13,
      }
    ]
  },
  {
    active: 14,
    titleOptions: ["网安", "科普","大赛"],
    title: "网安科普大赛",
    titleS: "",
    tip: " ",
    show: false,
    children: []
  },
];
export const isBlobDownloadSupported = function () {
  // 检查 Blob、URL、createObjectURL、download 属性是否存在
  const isSupport =
    typeof Blob !== 'undefined' &&
    typeof URL !== 'undefined' &&
    typeof URL.createObjectURL === 'function' &&
    typeof document.createElement('a').download !== 'undefined';
  return isSupport;
}
export const isWeChatAndroid = function () {
  const ua = navigator.userAgent.toLowerCase();
  const isWeChat = /micromessenger/i.test(ua);
  const isAndroid = /android/i.test(ua);
  return isWeChat && isAndroid;
}
export const provinceList = [
  '北京市', '天津市', '上海市', '重庆市',
  '河北省', '山西省', '辽宁省', '吉林省', '黑龙江省',
  '江苏省', '浙江省', '安徽省', '福建省', '江西省',
  '山东省', '河南省', '湖北省', '湖南省',
  '广东省', '海南省', '四川省', '贵州省', '云南省',
  '陕西省', '甘肃省', '青海省', '台湾省',
  '内蒙古自治区', '广西壮族自治区', '西藏自治区', '宁夏回族自治区', '新疆维吾尔自治区',
  '香港特别行政区', '澳门特别行政区'
];
export const addSuffix = function (shortName) {
  console.log("shortName",shortName);
  // 精确匹配全名，避免重复加后缀
  const found = provinceList.find(name => name.startsWith(shortName));
  return found || shortName; // 找不到就原样返回
}



// WEBPACK FOOTER //
// ./src/utils/index.js